const FormPlaceholder = {
  enter_note: "Enter Note",
  email: "Email",
  password: "Password",
  skillsAndKeyword: "Skills/Keywords:",
  job_info: "Job Title/Email/Name/Location:",
};
export { FormPlaceholder };
